import { useTranslation } from 'react-i18next';

const PATCH = '/images/alpenhof_patch_mobile.png';

export default function Location() {
  const { t } = useTranslation();

  const distances = [
    { label: t('locDist1'), value: '25 min', icon: 'ri-train-line' },
    { label: t('locDist2'), value: '10 min', icon: 'ri-water-flash-line' },
    { label: t('locDist3'), value: '45 min', icon: 'ri-plane-line' },
    { label: t('locDist4'), value: '90 min', icon: 'ri-landscape-line' },
  ];

  const highlights = [
    { icon: 'ri-home-smile-line',  title: t('locHL1Title'), description: t('locHL1Text') },
    { icon: 'ri-building-line',    title: t('locHL2Title'), description: t('locHL2Text') },
    { icon: 'ri-sailboat-line',    title: t('locHL3Title'), description: t('locHL3Text') },
    { icon: 'ri-compass-3-line',   title: t('locHL4Title'), description: t('locHL4Text') },
    { icon: 'ri-road-map-line',    title: t('locHL5Title'), description: t('locHL5Text') },
  ];

  return (
    <section id="lage">
      {/* ── MOBILE: Variante A „Der Aufnäher" ────────────────────────── */}
      <div className="sm:hidden bg-amber-50/50 py-16 px-4 relative overflow-hidden">
        {/* Hintergrund-Bild */}
        <img
          src="/images/Gemini_Generated_Image_2d6c9j2d6c9j2d6c.jpg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        />
        {/* dezenter Stoff-Look on top */}
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, #78350f 0 2px, transparent 2px 4px), repeating-linear-gradient(-45deg, #78350f 0 2px, transparent 2px 4px)",
          }}
        />
        <div className="relative max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] mb-3 px-4 py-1.5 bg-stone-100 text-stone-700 rounded-full">
            {t('locKicker')}
          </span>
          <h2 className="text-3xl font-serif text-stone-900 mb-4 leading-tight">
            {t('locTitleLine1')}<br />
            <span className="text-stone-700">{t('locTitleLine2')}</span>
          </h2>
          <p className="text-stone-700 leading-relaxed mb-8 max-w-xl mx-auto">
            {t('locLead')}
          </p>

          <img
            src={PATCH}
            alt="Lage Hotel Alpenhof Gauting – Aufnäher mit München, Gauting, Starnberger See und Alpen"
            loading="lazy"
            className="w-full max-w-md mx-auto mb-6"
            style={{
              transform: 'rotate(-2deg)',
              filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.18)) drop-shadow(0 4px 8px rgba(0,0,0,0.12))',
            }}
          />

          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto mb-10">
            {distances.map((d) => (
              <div key={d.label} className="flex items-center gap-3 bg-white/80 backdrop-blur-sm rounded-xl px-4 py-3 border border-amber-100 shadow-sm">
                <i className={`${d.icon} text-base text-amber-700`}></i>
                <div className="text-left">
                  <p className="text-[10px] uppercase tracking-wider text-stone-500 leading-none mb-1">{d.label}</p>
                  <p className="text-sm font-bold text-stone-900 leading-none">{d.value}</p>
                </div>
              </div>
            ))}
          </div>

          <ul className="space-y-4 max-w-xl mx-auto text-left">
            {highlights.map((h, i) => (
              <li key={i} className="flex items-start gap-3">
                <i className={`${h.icon} text-lg text-amber-700 mt-0.5 flex-shrink-0`}></i>
                <div>
                  <span className="text-sm font-semibold text-stone-900">{h.title}</span>
                  <p className="text-sm text-stone-700 leading-relaxed">{h.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ── DESKTOP: Hintergrundbild + Text-Overlay ──────────────────── */}
      <div className="hidden sm:block relative min-h-[420px] overflow-hidden bg-white">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <img
            src="/alpenhof_lage_starnberger_see_muenchen.jpg"
            alt="Lage Hotel Alpenhof Gauting – zwischen München, Starnberger See und den Alpen"
            loading="lazy"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-24">
          <div className="max-w-lg">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] mb-4 px-4 py-1.5 bg-white/80 text-stone-700 rounded-full">
              {t('locKicker')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-stone-900 mt-2 mb-4 leading-tight">
              {t('locTitleLine1')}<br />
              <span className="text-stone-700">{t('locTitleLine2')}</span>
            </h2>
            <p className="text-stone-700 leading-relaxed mb-8 max-w-md">
              {t('locLead')}
            </p>
            <ul className="space-y-4 mb-8">
              {highlights.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <i className={`${item.icon} text-lg text-stone-800 mt-0.5 flex-shrink-0`}></i>
                  <div>
                    <span className="text-sm font-semibold text-stone-900">{item.title}</span>
                    <p className="text-sm text-stone-700 leading-relaxed">{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div className="grid grid-cols-2 gap-3">
              {distances.map((item) => (
                <div key={item.label} className="flex items-center gap-3 bg-white/70 rounded-xl px-3 py-2.5 border border-stone-100">
                  <i className={`${item.icon} text-base text-amber-700`}></i>
                  <div>
                    <p className="text-[10px] uppercase tracking-wider text-stone-500 leading-none mb-0.5">{item.label}</p>
                    <p className="text-sm font-bold text-stone-900 leading-none">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
